export const mutations = {
  mutationsTempConfig(state, n = {}) {
    state.tempConfig = n;
    return state.tempConfig;
  },
  mutationsCategory(state, n = {}) {
    state.category = n;
    return state.category;
  }
};
